import { render } from "./StickyComponent.vue?vue&type=template&id=3ae90829&scoped=true"
import script from "./StickyComponent.vue?vue&type=script&lang=js"
export * from "./StickyComponent.vue?vue&type=script&lang=js"

import "./StickyComponent.vue?vue&type=style&index=0&id=3ae90829&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae90829"]])

export default __exports__